import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { MenuItem } from "@/app/ui/navigation/types";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";
import { EnumItemMainPurpose } from "@/app/services/generated/enums/enumItemMainPurpose.generated";

export const multiTenantMenu = {
  root: "navigation_multi_tenant_group",
  products_in_stock: "multi_tenant_products_in_stock",
  materials_in_stock: "multi_tenant_materials_in_stock",
};

export const buildMultiTenantMenuItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    name: multiTenantMenu.root,
    icon: "Share",
    visible: () =>
      hasPermissionsUsingUserStore([EnumUserPermission.menuMultiTenantView]),
    subMenus: [
      MenuItem.fromOpts({
        name: multiTenantMenu.products_in_stock,
        url: "/multi-tenant/products-in-stock",
        breadcrumbParentName: multiTenantMenu.root,
        view: (): Promise<any> =>
          import(
            /* webpackChunkName: "multi-tenant" */ "@/components/pages/multi-tenant/MultiTenantItemsInStockPage.vue"
          ),
        componentProps: {
          itemType: EnumItemMainPurpose.product,
        },
      }),
      MenuItem.fromOpts({
        name: multiTenantMenu.materials_in_stock,
        url: "/multi-tenant/materials-in-stock",
        breadcrumbParentName: multiTenantMenu.root,
        view: (): Promise<any> =>
          import(
            /* webpackChunkName: "multi-tenant" */ "@/components/pages/multi-tenant/MultiTenantItemsInStockPage.vue"
          ),
        componentProps: {
          itemType: EnumItemMainPurpose.material,
        },
      }),
    ],
    requiredUserPermissions: [EnumUserPermission.multiTenant],
  }),
];
